import Dialog from './Dialog.js';

class UnauthorizedLocationDialog extends Dialog {
    static create({id}) {
        return new UnauthorizedLocationDialog({id});
    }

    setMessage(message) {
        this.find('.message').text(message);
        return this;
    }
}

export default UnauthorizedLocationDialog;